import { BsCreditCard } from "react-icons/bs";
import { FaPix } from "react-icons/fa6";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ReactElement, useState } from "react";
import { CardsContainer, ExpansiveCardContainer, InstallmentOption } from "./styled";
import { InstallmentInfo, useBatchPayment } from "../../../../context/BatchPaymentContext";

export interface IExpansiveCardProps {
  defaultExpanded?: boolean;
  icon: ReactElement<any, any>;
  text: string;
  installments: InstallmentInfo[];
  installmentType: "C" | "P";
  handleSelect: (installment?: InstallmentInfo) => void;
}

function ExpansiveCard({
  icon,
  text,
  installments,
  installmentType,
  defaultExpanded,
  handleSelect
}: IExpansiveCardProps) {
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded ?? false)

  function handleNumbersToMoneyStr(value: number | undefined) {
    return `R$ ${(value ?? 0)?.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  }

  return (
    <Accordion
      disableGutters
      square
      sx={{ backgroundColor: 'transparent' }}
      defaultExpanded={defaultExpanded}
      onChange={(_: React.SyntheticEvent, expanded: boolean) => setExpanded(expanded)}
    >
      <AccordionSummary
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <ExpansiveCardContainer>
          <span className="installment-icon">
            {icon}
          </span>
          <span className="installment-title">
            {text}
          </span>
          <span className="expand-icon">
            {expanded
              ? <IoIosArrowDown />
              : <IoIosArrowForward />
            }
          </span>
        </ExpansiveCardContainer>
      </AccordionSummary>
      <AccordionDetails>
        {installments.map(installment => {
            const checked = installment.checked
            return (
              <InstallmentOption>
                <div className={`option ${checked ? "checked" : ""}`} onClick={() => installmentType === "P" ? handleSelect() : handleSelect(installment)}>
                  {!checked
                    ? <MdCheckBoxOutlineBlank style={{ fontSize: "18px", color: "#F58220" }} />
                    : <MdCheckBox style={{ fontSize: "18px", color: "#F58220" }} />}

                  <div>
                    <span>
                      {installment.month}x de <strong>{handleNumbersToMoneyStr(installment.installmentPrice)}</strong>
                    </span>
                    <span>{handleNumbersToMoneyStr(installment.totalPrice)}</span>
                  </div>

                  {installment.month === 12 && <span className="best-option">RECOMENDADO</span>}
                </div>
              </InstallmentOption>
            )
          }) ?? <></>}
      </AccordionDetails>
    </Accordion>
  )
}

export default function PaymentMethods() {
  const {
    pix,
    isPix,
    installments,
    handleSelectPix,
    handleSelectInstallment
  } = useBatchPayment();

  return (
    <CardsContainer>
      {/* {pix && <ExpansiveCard
        icon={<FaPix />}
        text="Pix"
        installments={[pix as InstallmentInfo]}
        installmentType="P"
        handleSelect={handleSelectPix}
        defaultExpanded={isPix || !(installments && installments.length > 0)}
      />} */}
      {installments && installments.length > 0  && <ExpansiveCard
        icon={<BsCreditCard />}
        text="Cartão de Crédito (em até 12x)"
        installments={installments}
        installmentType="C"
        handleSelect={(installment: InstallmentInfo = {} as InstallmentInfo) => handleSelectInstallment(installment)}
        defaultExpanded={!isPix}
      />}
    </CardsContainer>
  )
}